import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { url_path_emp_register } from ".";

export default function PreviewFilesEmp({ file, width, height }) {
  const [show, setShow] = useState(false);

  const isImage =
    file &&
    (file.endsWith(".png") || file.endsWith(".jpg") || file.endsWith(".jpeg"));
  const isPDF = file && file.endsWith(".pdf");

  return (
    <React.Fragment>
      <div className="avatar sm">
        {file ? (
          <>
            <button className="btn btn-secondary" onClick={() => setShow(true)}>
              ເບີ່ງ CV
            </button>
          </>
        ) : (
          "ບໍ່ມີໄຟລ໌ເອກະສານ"
        )}
      </div>
      <Modal
        show={show}
        centered
        scrollable
        size="lg"
        onHide={() => setShow(false)}
        className="text-center text-primary"
      >
        <Modal.Header closeButton onClick={() => setShow(false)}>
          <Modal.Title className="fs-5">
            <i className="icon-list" /> ເບິ່ງລາຍລະອຽດເອກະສານ
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="custom-modal-body text-center text-primary"
          style={{ backgroundColor: "transparent", height: "80vh" }}
        >
          {isImage ? (
            <img
              src={url_path_emp_register + file}
              className="img-fluid w-100 h-100"
              alt=""
              style={{ minHeight: height, minWidth: width }}
            />
          ) : isPDF ? (
            <iframe
              src={url_path_emp_register + file}
              className="w-100 h-100"
              style={{ minHeight: height, minWidth: width }}
              title="PDF Preview"
            />
          ) : (
            <p>ບໍ່ສາມາດແສງໄຟລ໌ນີ້</p>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
